<template>
  <v-layout id="resultsContainer" wrap>
    <v-flex v-if="searchObject.searchResult" xs12 class="results-top-bar">
      <v-layout wrap class="top-bar-wrap">
        <v-flex xs9 xl8 class="left-panel-bar">
          <v-layout wrap align-center>
            <v-flex xs6>
              <span
                :class="['visibility-controller', { disabled: hideResult }]"
                @click.stop="hideMapClicked"
              >
                {{ hideMap ? "SHOW MAP" : "HIDE MAP" }}
              </span>
            </v-flex>
            <v-flex xs6 style="position: relative">
              <loader-button
                v-if="hasMoreSearches && !hideMap"
                :loading="searchObject.loading"
                :disabled="searchObject.loading"
                btn-text="Load More"
                btn-class="btn-map"
                @handle-button-click="$emit('load-more-clicked')"
              />
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs3 xl4 class="right-panel-bar">
          <span
            :class="['visibility-controller', { disabled: hideMap }]"
            @click.stop="hideResultClicked"
          >{{ hideResult ? "SHOW LIST" : "HIDE LIST" }}</span>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-else class="panel-top-bar">
      {{ topHeader }}
    </v-flex>
    <v-flex xs12>
      <v-layout wrap class="results-wrapper" :style="calculateHeight">
        <template v-if="!isHideMap()">
          <v-flex
            :xs9="!hideResult"
            :xl8="!hideResult"
            :xs10="hideResult"
            :offset-xs1="hideResult"
            class="map-content"
          >
            <search-map-loader v-if="!displayMap" />
            <google-map-component
              :search-results="searchObject.data"
              :marked-marker="searchObject.markedMarker"
              @on-ready="mapLoaded = true"
              @marker-clicked="$emit('marker-clicked', $event)"
            />
          </v-flex>
        </template>
        <v-flex
          v-if="!hideResult"
          id="resultContent"
          :xs3="!isHideMap()"
          :xl4="!isHideMap()"
          :xs12="isHideMap()"
          :style="{
            overflow: searchObject.data.length > 0 ? 'auto' : 'hidden'
          }"
        >
          <search-results-container
            :assign-to-client="assignToClient"
            :search-object="searchObject"
            :has-more-searches="hasMoreSearches"
            @open-display-property="$emit('open-display-property', $event)"
            @load-more-clicked="$emit('load-more-clicked')"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import SearchResultsContainer from './SearchResultsContainer.vue'
import GoogleMapComponent from '../googlemap/GoogleMapComponent.vue'
import SearchMapLoader from '../common/search/SearchMapLoader.vue'
import LoaderButton from '../uiUtils/LoaderButton.vue'

export default {
  components: {
    SearchResultsContainer,
    GoogleMapComponent,
    SearchMapLoader,
    LoaderButton
  },

  props: {
    searchObject: {
      type: Object,
      required: true
    },
    assignToClient: {
      type: Object,
      default: () => ({})
    },
    topHeader: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      hideResult: false,
      mapLoaded: false,
      hasMoreSearches: true
    }
  },

  computed: {
    ...mapState('agent', ['hideMap']),

    calculateHeight() {
      if (this.searchObject.searchResult) {
        return {
          height: this.searchObject.searchResult
            ? 'calc(100vh - 180px - 8rem)'
            : 'calc(100vh - 48px - 40rem)'
        }
      }
      return { height: '100%' }
    },

    displayMap() {
      return !this.searchObject.loading && this.mapLoaded
    }
  },

  watch: {
    searchObject: {
      handler: function(objectValue) {
        const numSearchData = objectValue.data.length
        const isLessLimit = Math.floor(numSearchData / 15)
        if (isLessLimit < 1) {
          this.hasMoreSearches = false
        } else {
          this.hasMoreSearches = true
        }
      },
      deep: true
    }
  },

  methods: {
    ...mapMutations('common', {
      setMarkedId: 'SET_MARKED_ID',
      setMarkedMarker: 'SET_MARKED_MARKER'
    }),
    ...mapMutations('agent', {
      setHideMap: 'SET_HIDE_MAP'
    }),

    isHideMap() {
      return this.hideMap || !this.searchObject.searchResult
    },

    hideResultClicked() {
      this.hideResult = !this.hideResult
    },

    hideMapClicked() {
      this.setHideMap(!this.hideMap)
      this.setMarkedId('')
      this.setMarkedMarker(-1)
    }
  }
}
</script>

<style lang="sass" scoped>
#resultsContainer
  position: relative

.results-top-bar
  width: 100%
  height: 5rem

.panel-top-bar
  height: 5rem
  line-height: 5rem
  text-align: left
  padding-left: 3rem
  font-weight: 500
  text-transform: capitalize

.results-bottom-bar
  height: 3rem
  background: $hwayzBlack
  color: $hwayzShadow

.top-bar-wrap
  height: 100%
  align-items: center
  padding: 0 1rem

.left-panel-bar
  text-align: left
  .visibility-controller
    margin: 0 1rem

.visibility-controller
  font-weight: 500
  cursor: pointer

.results-wrapper
  overflow: hidden
  padding-left: 1rem
  width: 100%
  position: relative
  backface-visibility: hidden
  will-change: overflow

.disabled
  @extend %disabled-state
  opacity: 0.2

#resultContent
  height: 100%
  -webkit-overflow-scrolling: touch
  -ms-overflow-style: none

#resultContent, .map-content
  padding: 0 0.5rem

.map-content::-webkit-scrollbar
  display: none

// Custom scrollbar styling
#resultContent::-webkit-scrollbar-track
  background-color: $hwayzLightGray
  border: solid 1px $hwayzLightGray

#resultContent::-webkit-scrollbar
  width: 6px
  background-color: $hwayzLightGray

#resultContent::-webkit-scrollbar-thumb
  background-color: $hwayzShadow
  border-radius: 3px
</style>
